var React = require('react');

function IconArrowExpand (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"#fff","d":"M-329-220H46v812h-375z","key":0}),React.createElement("path",{"d":"M-.005.005L5.008 6.02 10.02.005z","key":1})]));
}

IconArrowExpand.defaultProps = {"width":"10","height":"6","viewBox":"0 0 10 6"};

module.exports = IconArrowExpand;

IconArrowExpand.default = IconArrowExpand;
